import { Component, inject, Input, OnInit, DestroyRef, signal } from "@angular/core";
import { DecimalPipe } from "@angular/common";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { BetConfigService } from "../../../../../../../../../shared/src/lib/services/bet-config.service";
import { getSportId } from "../../../../../../../../../shared/src";

@Component({
  selector: "app-bet-config",
  imports: [DecimalPipe],
  templateUrl: "./bet-config.component.html",
  styleUrl: "./bet-config.component.scss",
})
export class BetConfigComponent implements OnInit {
  @Input({ required: true }) market!: any;
  betConfigService = inject(BetConfigService);
  private readonly destroyRef = inject(DestroyRef);

  maxBetSize = signal<number | null>(null);
  minBetSize = signal<number | null>(null);

  ngOnInit() {
    this.betConfigService.betConfig$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((betConfig) => {
      const sportId = getSportId(this.market);
      if (betConfig && sportId && betConfig[sportId]) {
        this.minBetSize.set(betConfig[sportId].min_bet_size || null);
        this.maxBetSize.set(betConfig[sportId].max_bet_size || null);
      } else {
        this.minBetSize.set(null);
        this.maxBetSize.set(null);
      }
    });
  }
}
